<template>
  <div class="pt-8">
    <div class="pl-6 pr-4 pb-4 border-b border-zt-dark-200">
      <div class="flex items-center">
        <div class="flex-1 border border-zt-dark-300 rounded px-2 pt-1 relative">
          <label class="uppercase px-2 text-zt-dark-300 text-zt-xs bg-white absolute top--negative__8">{{
            $t('message.label.dni') }}</label>
          <input data-vs-input="cuil" v-model="inputCuil" type="text" class="w-full outline-none py-2"
            @keypress.enter="setInitialCuils" @blur="setInitialCuils" />
        </div>
        <div class="pl-4 flex-0">
          <span class="cuils--quantity">{{ $t("message.myTeam.added2", { lngt: partialCuils.length }) }}</span>
        </div>
      </div>
      <span class="cuils--label pl-3 pt-2 text-zt-md">{{ $t("message.myTeam.addTxt3", { dni: $t('message.label.dni') })
        }}</span>
    </div>
    <div class="pl-6 pr-4 pb-4">
      <div class="pl-2 pb-2">
        <div class="flex justify-between items-center">
          <v-checkbox data-vs-check-box="all-selected" color="primary" v-model="allSelected"
            :label="$t('message.myTeam.selectAll')" v-if="partialCuils.length > 0" />

          <div v-if="selectedCuils.length > 0">
            <zt-button data-vs-button="remove" @click="removeSelectedCuils" outlined>
              {{ $t("message.homeComponent.deleteSelected", { lngt: electedCuils.length }) }}
            </zt-button>
          </div>
        </div>
      </div>
      <div class="cuils--main border border-zt-dark-300">
        <template v-if="partialCuils.length === 0">
          <div class="text-zt-dark-300 h-full flex justify-center items-center">
            <div class="inline-flex">
              <zt-icon class="empty--icon" name="info-circle-alt" />
              <div>
                <p>{{ $t("message.homeComponent.visualizacionHere") }}</p>
                <p v-if="country !== 'BO'">
                  {{ $t("message.homeComponent.allTxt.allAddeds1", { dni: $t('message.label.dni') }) }}
                </p>
                <p v-else>{{ $t("message.homeComponent.allTxt.allAddeds2", { cis: $t('message.label.cis') }) }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="max-h-full overflow-y-auto">
            <div class="border-b border-zt-dark-300 pl-2" v-for="(cuil, index) in partialCuils" :key="index">
              <v-checkbox data-vs-check-box="selected-cuils" color="primary" v-model="selectedCuils" :value="cuil"
                :label="cuil" />
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="bg-zt-dark-200">
      <div class="flex py-4 pr-4">
        <div class="ml-auto">
          <zt-button data-vs-button="filters-cuils" @click="setFilterCuils">{{
            $t("message.settingsComponent.list.saveFilters") }}</zt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { includes, each, filter, isEmpty } from 'lodash'
import { addFilters } from '../../utils'
import { mapGetters } from 'vuex'

const formatCuils = (strCuils, arrCuils) => {
  if (!strCuils) {
    return null
  }

  if (strCuils.length < 5) {
    return null
  }

  if (arrCuils.length === 100) {
    return null
  }

  if (!includes(strCuils, ',') && strCuils.length < 21) {
    const cuil = strCuils.replace(/[^ña-z_&\d]+/gi, '')

    if (!cuil) {
      return null
    }

    return arrCuils.push(cuil)
  }

  const cuils = strCuils.split(',')

  each(cuils, cuil => {
    if (cuil && cuil.length >= 5 && cuil.length < 21 && arrCuils.length < 100) {
      arrCuils.push(cuil.replace(/[^ña-z_&\d]+/gi, ''))
    }
  })
}

export default {
  name: 'FormCuils',
  inject: ['cuilStore', 'setCuils', 'store', 'setFilters'],
  data() {
    return {
      partialCuils: [],
      inputCuil: '',
      selectedCuils: [],
      country: ''
    }
  },
  created() {
    this.country = this.getUser.pais
    this.partialCuils = [...this.cuilStore.cuils]
  },
  computed: {
    ...mapGetters({ getUser: 'getUser' }),
    allSelected: {
      set(val) {
        this.selectedCuils = []

        if (val) {
          each(this.partialCuils, cuil => this.selectedCuils.push(cuil))
        }
      },
      get() {
        return (
          this.selectedCuils.length > 0 &&
          this.selectedCuils.length === this.partialCuils.length
        )
      }
    }
  },
  methods: {
    setInitialCuils() {
      const inputValue = this.inputCuil.trim()
      if (!inputValue) {
        return (this.inputCuil = '')
      }

      formatCuils(this.inputCuil, this.partialCuils)
      this.inputCuil = ''
    },
    removeSelectedCuils() {
      const temp = filter(
        this.partialCuils,
        cuil => !includes(this.selectedCuils, cuil)
      )
      this.partialCuils = [...temp]
      this.selectedCuils = []
      this.applyFilter = isEmpty(this.partialCuils)
    },
    setStoreFilter(key, input) {
      const { filters } = this.store
      const newFilters = addFilters({ ...filters }, [key, input])
      this.setFilters(newFilters)
    },
    setFilterCuils() {
      this.setCuils(this.partialCuils)
      this.setStoreFilter('fiscalId', [...this.partialCuils])
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.cuils--label {
  color: rgba(0, 0, 0, 0.54);
}

.cuils--quantity {
  color: #707070;
}

.cuils--main {
  height: 330px;
}

.empty--icon {
  font-size: 35px;
}
</style>
